import { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/currency/get';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';

export const currencyList = (state: State) =>
  fetchWithParamValidation(() => getFromHamsClient(`/list`, state), {});
